<div class="row">
    <div class="col-lg-4 col-lg-offset-3">
        <div class="panel">
            <div class="panel-content" style="padding-top: 20px; padding-bottom: 20px;">
                <div class="account-wall">
                    <span class="user-brand">IQM Ispezioni</span>
                    <form class="form-signin" (ngSubmit)="onSubmit()" #loginForm="ngForm">
                        <div class="append-icon">
                            <input type="text" class="form-control input-lg" id="username"
                                   required autocomplete="off"
                                   placeholder="Username"
                                   [(ngModel)]="user.username" name="username"
                                   #username="ngModel"
                                   [ngClass]="{
                    'form-error': !(username.valid || username.pristine),
                    'form-success': username.valid
                 }">
                            <i class="icon-user"></i>
                            <div [hidden]="username.valid || username.pristine"
                                 class="form-error valid">
                                L'username è richiesto
                            </div>
                        </div>

                        <div class="append-icon" style="margin-top: 10px; margin-bottom: 20px;">
                            <input type="password" class="form-control input-lg" id="password"
                                   required placeholder="Password"
                                   [(ngModel)]="user.password" name="password"
                                   #password="ngModel"
                                   [ngClass]="{
                    'form-error': !(password.valid || password.pristine),
                    'form-success': password.valid
                 }">
                            <i class="icon-lock"></i>
                            <div [hidden]="password.valid || password.pristine"
                                 class="alert alert-danger">
                                La password è richiesta
                            </div>
                        </div>

                        <button type="submit" class="btn btn-lg btn-rounded btn-primary btn-block ladda-button"
                                [disabled]="!loginForm.form.valid">Accedi</button>

                        <div [hidden]="!signInFailed" class="alert alert-danger">
                            Username e/o password errati.
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
